define('modules/progress/constants',[],function(){
    'use strict';
    
    return {
        progressKey: 'course_progress',
        resultKey: 'course_result'
    };
});
